module.exports = __webpack_public_path__ + "static/img/8.7265fcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/8.png
// module id = qazi
// module chunks = 0